<template>
<div class="md-layout">
    <div class="md-layout-item md-size-40 md-small-size-hide">
      <main-table :data="data" :lease="true"  />
    </div>
    <div class="md-layout-item md-size-60 md-small-size-100">
        <tree-map-prod :data="data" pre="prod"/>
    </div>
</div>
</template>

<script>
import MainTable from '@/components/MainTable';
import TreeMapProd from '@/components/Graphs/TreeMapProd';

export default {
  name: 'production-cost',
  props:['data'],
  components: {MainTable, TreeMapProd},
}
</script>
<style>
.az-table-group{
    max-height: 320px;
    overflow: scroll;
}
</style>
